import React, { useState } from 'react';
import './player-card-pos.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode } from '@fortawesome/free-solid-svg-icons';
import Modal from '@/components/modal/modal.component';
import PlayerSelector from '@/components/SHARED/player-selector/player-selector.component';
import PlayerNameIcon from '@/components/PLAYER/player-blocks/components/status-elements/player-name-icon.component';

const PlayerCardPos = ({
  gameData,
  playerList,
  selectedPlayer
}) => {

  const [ showPlayerSelect, setShowPlayerSelect ] = useState(false);

  return (
    <div className='player-card-pos g-list-item'>
      <p><b>Selected Player</b></p>
      {
        selectedPlayer ?
          <div className='player-info'>
            <PlayerNameIcon player={selectedPlayer} />
          </div>
          :
          <div className='player-info'>
            <p><i>No player selected</i></p>
          </div>
      }
      <div className='buttons left'>
        <button 
          className='g-button small-btn' 
          onClick={() => setShowPlayerSelect(true)} > 
          Select Player
        </button>
        <button 
          className='g-button small-btn' >
        <FontAwesomeIcon icon={faBarcode} />
        </button>
      </div>
      <Modal
        show={!!showPlayerSelect}
        cancel={() => setShowPlayerSelect(false)}
        text="Select Player"
        closeButton={true} >
        <PlayerSelector
          playerList={playerList}
          chosenPlayers={[selectedPlayer]} />
      </Modal>
    </div>
  )
}

export default PlayerCardPos;